import { render, staticRenderFns } from "./bind-box-task.vue?vue&type=template&id=16b44130&scoped=true&"
import script from "./bind-box-task.vue?vue&type=script&lang=js&"
export * from "./bind-box-task.vue?vue&type=script&lang=js&"
import style0 from "./bind-box-task.vue?vue&type=style&index=0&id=16b44130&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b44130",
  null
  
)

export default component.exports